import React, { useEffect, useState } from 'react';
import { Formik, Form as FormikForm } from 'formik';
import { Button, Col, Form, Row } from 'react-bootstrap';
import FormField from '../layout/FormField';
import FormSelect from '../layout/FormSelect';
// import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import uploadImages from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import { useAuth } from '../../hooks/useAuth';
import { validateFileType } from '../../helpers/utils';
export const transitOptions = [
    { value: 'subway', label: 'Subway' },
    { value: 'train', label: 'Train' },
    { value: 'streetcar', label: 'Street Car' },
    { value: 'bus', label: 'Bus' }
];

export const selectorStyles = {
    input: (provided, state) => ({
        ...provided,
        padding: '5px 0px',
        name: 'transit_type'
    }),
    placeholder: (provided, state) => ({
        ...provided,
        color: '#ced4da'
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        marginLeft: 5
    }),
    menuList: (provided, state) => ({
        ...provided,
        fontSize: 14,
        color: '#a4a4a4'
    }),
    singleValue: (provided, state) => {
        const opacity = state.isDisabled ? 0.5 : 1;
        const transition = 'opacity 300ms';
        return { ...provided, opacity, transition };
    }
};

const AddAgencies = () => {
    const validate = Yup.object({
        name: Yup.string().required('Required'),
        email: Yup.string().required('Required'),
        phone: Yup.string()
            .matches(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4,5}$/, "Your phone number format must be '+1 233-343-2342'")
            .required('Required')
    });
    const [isValidSelected, setIsValidSelected] = useState(false);
    const [transitType, setTransitType] = useState([]);
    const [status, setStatus] = useState(false);
    const [isSelect, setIsSelect] = useState(false);
    const [agencyLogo, setAgencyLogo] = useState('');
    const { getToken } = useAuth();
    const token = getToken();
    const navigate = useNavigate();
    const handleSubmit = async (values, actions) => {
        if (transitType?.length === 0) {
            toast.error('Please select atleast one transit type.');
            return;
        }
        const { name, email, phone } = values;
        const token = getToken();
        const obj = {
            name: name,
            phone_no: phone,
            agency_name: name,
            agency_email: email,
            role: 'agency',
            email: email,
            password: 'abcd',
            agency_logo: '',
            agency_phone: phone,
            agency_transit_mediums: transitType?.map((item) => item.value).length ? transitType?.map((item) => item.value) : [],
            status: status
        };
        if (token) {
            const webApiCalls = new WebApiCalls();
            if (agencyLogo && isValidSelected) {
                const data = new FormData();
                data.append('image', agencyLogo);
                webApiCalls
                    .uploadImages(token, data)
                    .then((res) => {
                        if (res?.code == 200) {
                            obj.agency_logo = res?.data?.URL;
                            const webApiCalls = new WebApiCalls();
                            webApiCalls
                                .addNewAgency(token, obj)
                                .then((res) => {
                                    if (res && res?.code == 200) {
                                        toast.success('Agency has been added successfully.');
                                        navigate('/agencies');
                                    } else {
                                        toast.error(res.message);
                                    }
                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                        } else {
                            return null;
                        }
                    })
                    .catch((err) => {
                        console.log('Result here: ', err);
                    });
            } else {
                if (!isValidSelected) {
                    toast.error('Please select a valid image format');
                    return;
                }
                toast.error('Please select a logo image');
            }
        }
    };

    return (
        <>
            <Row className="d-flex justify-content-center">
                <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-5 rounded m-3">
                    <Formik
                        initialValues={{
                            name: '',
                            email: '',
                            phone: ''
                        }}
                        validationSchema={validate}
                        onSubmit={handleSubmit}
                        enableReinitialize={true}
                    >
                        {(formik) => (
                            <FormikForm
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    formik.handleSubmit();
                                }}
                            >
                                <Row>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label className="mb-0">Agency Logo</Form.Label>
                                            <Form.Control
                                                type="file"
                                                className="form-control common-input"
                                                onChange={async (e) => {
                                                    setIsSelect(true);
                                                    const { name } = e.target.files[0];
                                                    if (!validateFileType(name)) {
                                                        setIsValidSelected(false);
                                                        toast.error('File format is not supported!');
                                                        return;
                                                    }
                                                    setAgencyLogo(e.target.files[0]);
                                                    setIsValidSelected(true);
                                                }}
                                                accept=".gif,.jpg,.jpeg,.png"
                                                name="agencyLogo"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            className="form-control common-input"
                                            label="Name"
                                            name="name"
                                            type="text"
                                            placeholder="Enter Name"
                                            onChange={formik.handleChange}
                                            value={formik.values?.name}
                                        />
                                    </Col>
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            className="form-control common-input"
                                            label="Email"
                                            name="email"
                                            type="email"
                                            placeholder="Enter Email"
                                            onChange={formik.handleChange}
                                            value={formik.values?.email}
                                        />
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <FormField
                                            onKeyDown={(e) => {
                                                if (e.target.value.length === 0 && e.key !== 'Backspace') {
                                                    e.target.value = '+' + e.target.value;
                                                }
                                                if (e.target.value.length === 2 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + ' ';
                                                }
                                                if (e.target.value.length === 6 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                if (e.target.value.length === 10 && e.key !== 'Backspace') {
                                                    e.target.value = e.target.value + '-';
                                                }
                                                formik.setFieldValue('phone', e.target.value);
                                            }}
                                            className="form-control common-input"
                                            label="Phone"
                                            name="phone"
                                            type="phone"
                                            placeholder="Enter Phone"
                                            value={formik.values?.phone}
                                        />
                                    </Col>
                                </Row>

                                <Row>
                                    {/* <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        className="form-control common-input"
                                        type="password"
                                        placeholder="Enter new password"
                                        required
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                    <Form.Text className="text-danger">
                                        Required
                                    </Form.Text>
                                </Form.Group>
                            </Col> */}
                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <select className="common-selector" value={status} onChange={(e) => setStatus(e.target.value)}>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </Form.Group>
                                    </Col>

                                    <Col xs={12} sm={12} md={6} lg={6} className="mb-3">
                                        {/* <div className='form-label mb-0'>Transit Type</div> */}
                                        <Form.Group>
                                            <Form.Label className="form-label mb-2">Transit Type</Form.Label>
                                            <Select
                                                options={transitOptions}
                                                isMulti
                                                customStyles={selectorStyles}
                                                value={transitType}
                                                onChange={(e) => setTransitType(e)}
                                            />
                                            {/* <Form.Text className="text-danger">
                                        Required
                                    </Form.Text> */}
                                        </Form.Group>
                                        {/* <Field name="transit_type" onChange={val => {
                                    const s = val.map(item => item.value).join(',')
                                    // formik.setFieldValue("transit_type", s)

                                }
                                } component={CustomSelector} options={transitOptions} /> */}
                                        {/* <Select isMulti options={transitOptions}
                                    value={selectedOption}
                                    // value={defaultValue(options, formik.values.transit_type)} 
                                    customStyles={selectorStyles}
                                    onChange={(e) => {
                                        console.log("e here:    ", e)
                                        // formik.setFieldValue("transit_type", e.value)
                                        // formik.handleChange(e)
                                    }} /> */}
                                    </Col>
                                </Row>

                                <div className="text-end">
                                    <Link to="/agencies">
                                        <Button type="submit" className="theme-cancel-btn me-3">
                                            Cancel
                                        </Button>
                                    </Link>
                                    <Button type="submit" className="theme-btn">
                                        Save
                                    </Button>
                                </div>
                            </FormikForm>
                        )}
                    </Formik>
                </Col>
            </Row>
        </>
    );
};
export default AddAgencies;

//<Row className="d-flex justify-content-center">
//                <Col xs={12} sm={12} md={11} lg={11} className="shadow-lg p-3 m-3">
//                    <Formik
// initialValues={{
//     first_name: '',
//     email: '',
//     // control_number: '',
//     phone_no: '',
//     address: '',
//     state: '',
//     city: '',
//     zipcode: '',
//     phone: '',
//     financial: ''
// }}
// validationSchema={validate}
// onSubmit={(values) => {
//     console.log('member Values', values);
//     }}
// >
//     {(formik) => (
//         <Form>
//             <Row>
//                 <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
//                     <FormField className="form-control common-input" label="Commuter Name" name="name" type="text" placeholder="Enter name" />
//                 </Col>
//                 <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
//                     <FormField className="form-control common-input" label="Email" name="email" type="email" placeholder="Enter email" />
//                 </Col>
//                 {/* <FormField className="form-control common-input" label="Phone Number" name="control_number" type="text" /> */}
//             </Row>

//             <Row>
//                 <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
//                     <FormField className="form-control common-input" label="Phone Number" name="phone_no" type="text" placeholder="Enter phone number" />
//                 </Col>
//                 <Col xs={12} sm={12} md={6} lg={6} className="mb-2">
//                     <label>Gender</label>
//                      <Field as="select" name="gender" className="gender-selector" label="Gender">
//                         <option value="" selected disabled hidden>Gender</option>
//                         <option value="male">Male</option>
//                         <option value="female">Female</option>
//                     </Field>
//                     {/*
//                     <Form.Select aria-label="Default select example">
//                         <option value="" selected disabled hidden>Gender</option>
//                         <option value="male">Male</option>
//                         <option value="female">Female</option>
//                     </Form.Select> */}
//                     {/* <FormField className="form-control common-input" label="address" name="address" type="text" placeholder="Gender" /> */}
//                 </Col>
//             </Row>

//             <Row>
//                 <Col xs={12} sm={12} md={6} lg={6}>
//                     <FormField className="form-control common-input" label="state" name="state" type="text" />
//                 </Col>
//                 <Col xs={12} sm={12} md={6} lg={6}>
//                     <FormSelect label="city" name="city" data={cityData} />
//                 </Col>
//             </Row>

//             <Row>
//                 <Col xs={12} sm={12} md={6} lg={6}>
//                     <FormField label="zipcode" name="zipcode" type="text" />
//                 </Col>
//                 <Col xs={12} sm={12} md={6} lg={6}>
//                     <FormField label="phone" name="phone" type="text" />
//                 </Col>
//             </Row>

//             <FormField label="financial" name="financial" type="text" />
//             <div className="text-end">
//                 <Link to="/members">
//                     <Button type="submit" className="theme-cancel-btn me-3">
//                         Cancel
//                     </Button>
//                 </Link>
//                 <Button type="submit" className="theme-btn">
//                     Add
//                 </Button>
//             </div>
//         </Form>
//     )}
// </Formik>
//     </Col>
// </Row> */}
